
import SEOHead from '../../components/seo/SEOHead';
import ProductsHeroSection from './components/ProductsHeroSection';
import ProductCategoriesSection from './components/ProductCategoriesSection';
import FeaturedProductsSection from './components/FeaturedProductsSection';
import AllProductsSection from './components/AllProductsSection';

export default function Products() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "顺年陈产品中心",
    "description": "精选年份茶，匠心制作每一款茶品。传承古法工艺，呈现时光之美。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`,
    "mainEntity": {
      "@type": "ItemList",
      "name": "年份普洱茶产品",
      "description": "顺年陈精选年份普洱茶系列产品",
      "numberOfItems": 8
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="产品中心 - 顺年陈精选年份茶"
        description="精选年份茶，匠心制作每一款茶品。传承古法工艺，呈现时光之美。浏览顺年陈全系列普洱茶、六堡茶等年份茶产品。"
        keywords="年份茶,普洱茶,六堡茶,茶叶产品,顺年陈产品,高端茶叶"
        canonical="/products"
        structuredData={structuredData}
      />
      <ProductsHeroSection />
      <ProductCategoriesSection />
      <FeaturedProductsSection />
      <AllProductsSection />
    </div>
  );
}
